<template>
  <Navbar />
  <div class="main_section">
    <div class="title col">
      <h1>
        歸還入庫
      </h1>
    </div>
    <div class="info_wrap col">
      <div class="fixed_info">
        <div>
          <p>
            申請人員 : {{ utilsStore.user.name }}
          </p>
        </div>
        <div>
          <p>
            申請入庫日期 : {{ utilsStore.today }}
          </p>
        </div>
      </div>
      <div class="content">
        <!-- 資產編號 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              <span>*</span>資產編號：
            </div>
            <input ref="inputElement" type="text" class="form-control" placeholder="請輸入資產編號"
              v-model="formParams.AssetsId">
          </div>
        </div>
        <!-- 資產名稱 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              資產名稱：
            </div>
            <input type="text" class="form-control readonly_box" v-model="formParams.AssetName" readonly>
          </div>
        </div>
        <!-- 資產類型 -->
        <div class="col-12">
          <div class="input-group mb-4">
            <div class="input-group-prepend">
              資產類型：
            </div>
            <input type="text" class="form-control readonly_box" v-model="formParams.AssetType" readonly>
          </div>
        </div>
        <!-- 資產狀態 -->
        <div class="col-12">
          <div class="input-group" :class="{ 'mb-4': !wrongStatus }">
            <div class="input-group-prepend">
              資產狀態：
            </div>
            <input type="text" class="form-control readonly_box" v-model="formParams.Status" readonly>
          </div>
        </div>
        <div v-show="wrongStatus" class="col-12">
          <div class="input-group">
            <div style="visibility: hidden; max-width: 114px;" class="input-group-prepend d-none d-md-block">
              <p>1</p>
            </div>
            <span style="color:rgb(216, 13, 13); font-weight: 700; font-size: 20px; margin-left: 0px;">{{ alertMsg
              }}</span>
            <input type="text" style="visibility: hidden; width: 1%;" class="form-control d-none d-md-block flex-1">
          </div>
        </div>
        <!-- 頁籤儲位 區域&櫃位 -->
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-md-12 col-12">
            <div class="input-group mb-3">
              <div class="input-group-prepend"><span class="required">*</span>儲位區域：</div>
              <select class="form-select" id="floatingSelect" v-model="formParams.Area_Id"
                @change="async () => { DropdownArray.Layer = await apiStore.getLayer(formParams.Area_Id); formParams.Layer_Id = ''; }">
                <option value="">--請選擇--</option>
                <option v-for="option in DropdownArray.Area" :key="option.Id" :value="option.Id">{{ option.Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-12 col-12">
            <div class="input-group mb-3 justify-content-end">
              <div class="input-group-prepend"><span class="required">*</span>儲位櫃位：</div>
              <select class="form-select" id="floatingSelect" v-model="formParams.Layer_Id">
                <option v-if="DropdownArray.Layer.length == 0" value="">--請先選擇區域櫃位--</option>
                <template v-else>
                  <option value="">--請選擇--</option>
                  <option v-for="option in DropdownArray.Layer" :key="option.Id" :value="option.Id">{{ option.Name }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xl-6 col-lg-12 col-md-12 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                <span>*</span>數量：
              </div>
              <input class="input-number" type="number" v-model="formParams.Count" min="1" :readonly="!canEdit"
                :class="{ readonly_box: !canEdit }" />
            </div>
          </div>
          <div class="col-xl-6 col-lg-12 col-md-12 col-12">
            <div class="input-group mb-4">
              <div class="input-group-prepend">
                單位：
              </div>
              <input type="text" class="input-number readonly_box" readonly v-model="formParams.Unit">
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="input-group">
            <div class="input-group-prepend" style="max-width: 114px;">
              備註：
            </div>
            <textarea rows="3" class="col" placeholder="最多輸入500字" maxlength="500" v-model="formParams.Memo"></textarea>
          </div>
        </div>
        <div class="d-flex justify-content-center mt-3">
          <button class="send_btn" :disabled="!canSubmit" :class="{ send_btn_disabled: !canSubmit }"
            @click="handleCreate">新增</button>
        </div>
      </div>
      <!-- 頁籤部分 -->
      <div class="tab_section mt-5">
        <nav>
          <!-- 標頭 -->
          <div class="nav nav-tabs" id="nav-tab" role="tablist">
            <button v-for="tab in parseInt(tabData.length)" :key="tab" :class="['nav-link', { active: tab === 1 }]"
              data-bs-toggle="tab" :data-bs-target="'#tab' + (tab)" type="button" role="tab" :aria-selected="tab === 0">
              {{ tab }}
            </button>
          </div>
        </nav>
        <div v-if="tabData.length > 0" class="tab-content" id="nav-tabContent">
          <div v-for="(tab, index) in tabData" :key="index"
            :class="['tab-pane', 'fade', { 'show active': index === 0 }]" :id="'tab' + (index + 1)" role="tabpanel"
            aria-labelledby="tab1-tab">
            <!-- 頁籤資產類型 -->
            <div class="row">
              <div class="col-12">
                <div class="input-group mb-3 check_box_wrap">
                  <div class="input-group-prepend check_box">
                    資產類型：
                  </div>
                  <div class="d-flex align-items-center radio_wrap">
                    <input type="radio" class='form-check-input check_box' id="radio1"
                      style="border-radius: 100%; width: 16px; height: 16px; margin-top: 0;" value="資產"
                      v-model="tab.itemAssetType" :disabled="tab.itemAssetType !== '資產'" />
                    <label class="form-check-label check_box" for='radio1'>資產</label>
                    <input type="radio" class='form-check-input check_box ' id="radio2"
                      style="border-radius: 100%; width: 16px; height: 16px; margin-top: 0;" value="存貨"
                      v-model="tab.itemAssetType" :disabled="tab.itemAssetType !== '存貨'" />
                    <label class="form-check-label check_box" for='radio2' data-toggle="tooltip" data-placement="top"
                      title="註記此資產僅限特定專案出貨所使用">存貨</label>
                    <input type="radio" class='form-check-input check_box' id="radio3"
                      style="border-radius: 100%; width: 16px; height: 16px; margin-top: 0;" value="耗材"
                      v-model="tab.itemAssetType" :disabled="tab.itemAssetType !== '耗材'"
                      @change="storageStore.resetUnitCount('tab', index)" />
                    <label class="form-check-label check_box" for='radio3'>耗材</label>
                  </div>
                </div>
              </div>
            </div>
            <!-- 頁籤資產編號 -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">資產編號：</div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemAssetsId" maxlength="10"
                  placeholder="BFXXXXXXXX" disabled />
              </div>
            </div>
            <!-- 頁籤專案代碼 -->
            <div class="col form_search_wrap">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  專案代碼：
                </div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemProjectCode" readonly />
              </div>
            </div>
            <!-- 頁籤專案名稱 -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">專案名稱：</div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemProjectName" readonly />
              </div>
            </div>
            <!-- 頁籤 設備總類 & 設備分類-->
            <div class="row g-0">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">設備總類：</div>
                  <input type="text" class="form-control readonly_box" v-model="tab.itemEquipTypeName" readonly />
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">設備分類：</div>
                  <input type="text" class="form-control readonly_box" v-model="tab.itemEquipCategoryName" readonly />
                </div>
              </div>
            </div>
            <!-- 頁籤儲位 區域&櫃位 -->
            <div class="row g-0">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend"><span class="required">*</span>儲位區域：</div>
                  <select class="form-select" id="floatingSelect" v-model="tab.itemArea_Id"
                    @change="async () => { tab.LayerArray = await apiStore.getLayer(tab.itemArea_Id); tab.itemLayer_Id = ''; }">
                    <option value="">--請選擇--</option>
                    <option v-for="option in DropdownArray.Area" :key="option.Id" :value="option.Id">{{ option.Name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3 justify-content-end">
                  <div class="input-group-prepend"><span class="required">*</span>儲位櫃位：</div>
                  <select class="form-select" id="floatingSelect" v-model="tab.itemLayer_Id">
                    <option v-if="tab.LayerArray.length == 0" value="">--請先選擇區域櫃位--</option>
                    <template v-else>
                      <option value="">--請選擇--</option>
                      <option v-for="option in tab.LayerArray" :key="option.Id" :value="option.Id">{{ option.Name }}
                      </option>
                    </template>
                  </select>
                </div>
              </div>
            </div>
            <!-- 頁籤物品名稱 -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">物品名稱：</div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemAssetName" readonly />
              </div>
            </div>
            <!-- 頁籤廠商 -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">廠商：</div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemVendorName" readonly />
              </div>
            </div>
            <!-- 頁籤規格 -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">規格：</div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemProductSpec" readonly />
              </div>
            </div>
            <!-- 頁籤型號 -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">型號：</div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemProductType" readonly />
              </div>
            </div>
            <!-- 頁籤S/N -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">S/N：</div>
                <input type="text" class="form-control readonly_box" v-model="tab.itemSN" readonly />
              </div>
            </div>
            <!-- 頁籤 數量 & 單位 -->
            <div class="row g-0">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend info"><span v-if="tab.itemAssetType === '耗材'">*</span>數量：</div>
                  <input v-if="tab.itemAssetType === '耗材'" class="input-number" type="number" v-model="tab.itemCount"
                    min="1">
                  <input v-else class="input-number readonly_box" type="number" v-model="tab.itemCount" min="1"
                    readonly>
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3 justify-content-end">
                  <div class="input-group-prepend">單位：</div>
                  <input class="form-select readonly_box" type="text" v-model="tab.itemUnit" min="1" readonly>
                </div>
              </div>
            </div>
            <!-- 頁籤保固期限 -->
            <div class="row g-0">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    保固期限：
                  </div>
                  <input type="text" class="form-control readonly_box" v-model="tab.itemWarrantyDate" readonly>
                </div>
              </div>
            </div>
            <!-- 頁籤 保固 開始&結束 -->
            <div class="row g-0">
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">保固開始日：</div>
                  <input type="text" class="form-control readonly_box" v-model="tab.itemWarrantyStartDate" readonly />
                </div>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-12">
                <div class="input-group mb-3">
                  <div class="input-group-prepend">保固到期日：</div>
                  <input type="text" class="form-control readonly_box" v-model="tab.itemWarrantyEndDate" readonly />
                </div>
              </div>
            </div>
            <!-- 頁籤備註 -->
            <div class="col">
              <div class="input-group mb-3">
                <div class="input-group-prepend">
                  備註：
                </div>
                <textarea class="col" rows="3" placeholder="最多輸入500字" maxlength="500" v-model="tab.itemMemo"></textarea>
              </div>
            </div>
            <!-- 頁籤選擇檔案 -->
            <div class="col">
              <div class="input-group">
                <div class="input-group-prepend">資產照片：</div>
                <div class="mb-3 file_wrap">
                  <button class='choose_btn' @click="storageStore.chooseFile(index)">選擇檔案</button>
                  <input type="file" accept="image/*" style="display: none;" multiple
                    @change="utilsStore.handleImgChange($event, tab)" />
                </div>
              </div>
            </div>
            <div class="selected_file col">
              <div class="input-group">
                <div class="input-group-prepend">已選擇檔案：</div>
                <div class="selected_file_wrap">
                  <div v-for="(file, file_index) in tab.viewFile" :key="file_index" class="file_upload_wrap">
                    <p>{{ file.FileName }}
                      <img class="view_icon" src="@/assets/view.png" style="margin-left: 10px;"
                        @click="utilsStore.viewFile(file)" data-bs-toggle="modal" data-bs-target="#viewFile_modal">
                      <img class="trash_icon" src="@/assets/trash.png" style="margin-left: 10px;"
                        @click="utilsStore.deleteImgFile('new', tab, file_index)">
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ViewFile Modal -->
        <view_modal />
      </div>
      <div class="col button_wrap">
        <button class="back_btn" @click="utilsStore.goBack">回上一頁</button>
        <button class="send_btn" @click="submit">送出</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import view_modal from "@/components/view_modal.vue"
import {
  ref,
  onMounted,
  reactive,
  watch,
  toRaw
} from 'vue';
import Navbar from '@/components/Navbar.vue';
import router from '@/router';
import axios from '@/axios/tokenInterceptor';
import { useAPIStore, useUtilsStore } from '@/store';
import { storeToRefs } from 'pinia';
import { useStorageStore } from '@/store/storage/_index';
const inputElement = ref(null);
const canSubmit = ref(false);
const canEdit = ref(true);
const wrongStatus = ref(false);
const alertMsg = ref('');
const utilsStore = useUtilsStore();
const apiStore = useAPIStore();
const storageStore = useStorageStore();
const { middleForm, tabData, DropdownArray } = storeToRefs(storageStore);
const formParams = reactive({
  Status: '',
  AssetName: '',
  AssetType: '',
  Area_Id: '',
  Layer_Id: '',
  AssetsId: '',
  Count: 1,
  Unit: '',
  Memo: '',
});
onMounted(async () => {
  storageStore.$reset();
  DropdownArray.value.EquipType = await apiStore.getEquipType();
  DropdownArray.value.Area = await apiStore.getArea();
  // Focus the input element when the component is mounted
  inputElement.value.focus();
  utilsStore.getDate();
});

async function submit() {
  /**
   * 建立一張空的單(取得單號)
   * @returns {Promise<Object>} { AI_ID: String, itemId: String[]}
   */
  const createAI_ID = async () => {
    let requestData = [];
    tabData.value.forEach(tab => {
      requestData.push({
        itemAssetsId: tab.itemAssetsId ?? null,
        itemArea_Id: tab.itemArea_Id ?? null,
        itemLayer_Id: tab.itemLayer_Id ?? null,
        itemCount: tab.itemCount ?? null,
        itemMemo: tab.itemMemo ?? null,
      });
    });
    console.log('requestData', requestData);
    try {
      const data = (await axios.post('/AssetsInMng/OldAssetsIn', requestData)).data;
      return data.resultList
    } catch (error) {
      console.error(error);
      return {
        AI_ID: null,
        itemId: [],
      }
    }
  }
  /**
   * 使用itemId 來儲存頁籤照片
   * @param {String} itemId 頁籤的itemId(PK)
   * @param {Object} tab 頁籤內容
   * @param {Number} index 順序，顯示錯誤訊息用
   * @returns {Promise<String>} 'success' or other error
   */
  const saveSingleTab = async (itemId, tab, index) => {
    return new Promise(async (resolve, reject) => {
      console.log(`tab${index}: ${tab.itemAssetsId}, itemId: ${itemId}`);
      let form = new FormData;
      form.append('itemId', itemId);
      tab.newFile.forEach((file) => {
        form.append('newFile', file);
      })
      try {
        axios.post('/AssetsInMng/UploadFile', form)
        .then((res)=>{
          const data = res.data;
          if(data.state === 'success') resolve('success')
          else throw data.messages
        })
        .catch((err)=>{
          console.error(`第${index + 1}個頁籤傳送失敗`);
          throw err
        })
        resolve('success')
      } catch (error) {
        // reject(error);
        console.error(error);
        resolve('fail');
      }
    })
  }
  /**
   * 驗證頁籤的內容(頁籤最小數量、必填)
   * @returns {Boolean} Invalid: true, Valid: false
   */
  const checkTabInvalid = () => {
    // 頁籤數量至少為一
    if (tabData.value.length === 0) {
      alert('請至少歸還一樣資產');
      return true
    }
    // 檢查必填
    let InputErrorMessages = '';
    let RequireCheckList = {
      itemArea_Id: '儲位區域',
      itemLayer_Id: '儲位櫃位',
    }
    tabData.value.forEach((tab, index) => {
      InputErrorMessages += utilsStore.checkTabRequired(tab, RequireCheckList, index);
      utilsStore.checkTabRequired();
    })
    if (InputErrorMessages) {
      alert(InputErrorMessages);
      return true
    }
    // Valid
    return false
  }
  if (checkTabInvalid()) return
  try {
    let { AI_ID, itemId } = await createAI_ID();
    if (!AI_ID) throw '建立AI_ID異常'
    console.log('取得ID', AI_ID);
    // 儲存頁籤
    let tabPromises = [];
    tabData.value.forEach((tab, index) => {
      if(tab.newFile.length > 0) tabPromises.push(saveSingleTab(itemId[index], toRaw(tab), index));
    })
    await Promise.all(tabPromises)
      .then(async result => {
        const allSuccess = result.every(result => result === 'success');
        // 轉狀態
        if (!allSuccess) console.warn('上傳頁籤檔案有誤');
        await storageStore.FinishStorageProcess(AI_ID, false);
      })
      .catch(error => {
        throw error
      })
  } catch (error) {
    console.error(error);
    alert(error);
  }
}
const resetFormParams = (resetId = true) => {
  if (resetId) formParams.AssetsId = '';
  formParams.AssetName = '';
  formParams.AssetType = '';
  formParams.Area_Id = '';
  formParams.Layer_Id = '';
  formParams.Status = '';
  formParams.Count = 1;
  formParams.Unit = '';
  formParams.Memo = '';
}

const handleCreate = async () => {
  /**
   * 檢查新增的頁籤資產編號是否與已存在的頁籤資產編號相同
   */
  const checkRepeatInvalid = () => {
    let originArray = tabData.value.map(tab => toRaw(tab).itemAssetsId);
    return originArray.includes(formParams.AssetsId)
  }
  //checkInvalid
  if (!utilsStore.checkRequired(formParams, ['AssetsId', 'Area_Id', 'Layer_Id', 'Count'])) return
  if (checkRepeatInvalid()) {
    alert('請勿歸還相同資產')
    return
  }
  // update middleForm
  let temp = {
    itemArea_Id: formParams.Area_Id,
    itemLayer_Id: formParams.Layer_Id,
    itemMemo: formParams.Memo,
    itemCount: formParams.Count,
    itemUnit: formParams.Unit,
  }
  Object.assign(middleForm.value, temp);
  //create
  // console.log('to Raw', toRaw(middleForm.value));
  await storageStore.insertTab(false, toRaw(middleForm.value));
  resetFormParams(true);
}
watch(() => formParams.AssetsId, async (newValue, oldValue) => {
  const processIntoTabData = (data, upperData) => {
    let tempData = {
      itemAssetType: data.AssetType,
      itemAssetsId: data.AssetsId,
      itemProjectCode: data.ProjectCode,
      itemProjectName: data.ProjectName,
      itemEquipTypeName: data.EquipTypeName,
      itemEquipCategoryName: data.EquipCategoryName,
      itemArea_Id: upperData.Area_Id,
      itemLayer_Id: upperData.Layer_Id,
      itemAssetName: data.AssetName,
      itemVendorName: data.VendorName,
      itemProductSpec: data.ProductSpec,
      itemProductType: data.ProductType,
      itemSN: data.SN,
      itemUnit: upperData.Unit,
      itemCount: upperData.Count,
      itemWarranty: data.WarrantyDate,
      itemWarrantyStartDate: data.WarrantyStartDate,
      itemWarrantyEndDate: data.WarrantyEndDate,
      itemMemo: upperData.Memo,
      EquipCategoryArray: [], //設備分類
      LayerArray: [], // 櫃位
      newFile: [],
      viewFile: [],
    }
    Object.assign(middleForm.value, tempData);
    // storageStore.insertTab(false, middleForm.value);
  }
  if (newValue.length !== 10) {
    resetFormParams(false);
    storageStore.clear();
    return
  }
  let data = {};
  try {
    const response = await axios.get(`/GetDBdata/GetAssetInfo?id=${newValue}`);
    data = response.data;
    if (data.state === 'success') {
      // console.log('資產資料', data.resultList);
      formParams.AssetName = data.resultList.AssetName;
      formParams.AssetType = data.resultList.AssetType;
      formParams.Area_Id = data.resultList.Area_Id ?? '';
      formParams.Layer_Id = data.resultList.Layer_Id ?? '';
      formParams.Unit = data.resultList.Unit;
      formParams.Status = data.resultList.Status;
      formParams.Count = 1;
      formParams.Memo = data.resultList.Memo;
      DropdownArray.value.Layer = await apiStore.getLayer(formParams.Area_Id);
      // 如為非耗材 1.資產數量為一，且不可更改 2.Status不對，不能提交
      if (data.resultList.AssetType !== '耗材') {
        // 1.
        canEdit.value = false;
        // 2.
        wrongStatus.value = true;
        canSubmit.value = false;
        switch (data.resultList.Status) {
          case '在庫':
            alertMsg.value = '此資產已在庫，無法重複歸還。'
            break;
          case '報廢':
            alertMsg.value = '此資產已被報廢，無法進行歸還作業。'
            break;
          case '已被設備整合':
            alertMsg.value = '此資產已被整合進設備整合箱，無法進行歸還作業。'
            break;
          default:
            canSubmit.value = true;
            wrongStatus.value = false;
            break;
        }
      }
      //如為耗材
      else {
        canEdit.value = true;
        canSubmit.value = true;
      }

    } else if (data.state === 'error') {
      console.log(data.messages);
      canEdit.value = true;
      canSubmit.value = false;
      wrongStatus.value = false;
      resetFormParams(false);
    }
  } catch (error) {
    console.error(error);
  } finally {
    // 整理資料
    if (canSubmit.value) processIntoTabData(data.resultList, toRaw(formParams));
    else storageStore.clear();
  }
}, {
  immediate: false
});
</script>


<style lang="scss" scoped>
@import '@/assets/css/global.scss';

.button_wrap {
  display: flex;
  justify-content: space-between;
  margin: 30px auto 5%;
  width: 210px;
}

.back_btn {
  @include back_to_previous_btn;

  &:hover {
    background-color: #5d85bb;
  }
}

.send_btn {
  @include search_and_send_btn;

  &:hover {
    background-color: #5e7aa2;
  }
}

.send_btn_disabled {
  background: #878787;

  &:hover {
    background: #878787;
  }
}

.readonly_box {
  @include readonly_box;
}

.input-number {
  @include count_btn;
}

span {
  @include red_star;
}

.main_section {
  .info_wrap {
    .fixed_info {
      @include fixed_info;

      p {
        font-size: 20px;
        margin-bottom: 0;
      }
    }

    .content {
      @include content_bg;

      .readonly_box,
      .form-control {
        width: 100%;
        height: 35px;
      }

      .input-group-prepend {
        color: white;
        font-weight: 700;
        font-size: 20px;
      }
    }

    .tab_section {
      .nav {
        overflow-x: auto;
        overflow-y: hidden;
        flex-wrap: nowrap;
        border: none;

        ::-webkit-scrollbar {
          height: 6px;
          border: 1px solid rgb(219, 218, 218);
          border-radius: 5px;
          width: 8px;
        }

        ::-webkit-scrollbar-thumb {
          display: block;
          border-radius: 5px;
          background-color: rgb(176, 175, 175);
          border: 1px solid rgb(86, 85, 85);
        }
      }

      .nav-tabs {
        button {
          @include tab_section_num;
          background: #5C7897;
        }

        .active {
          @include tab_section_num;
          background: #3E4E5F;
        }
      }

      .tab-content {
        background: #3E4E5F;
        border-radius: 0 0 20px 20px;

        .storage_dropdown {

          .col:nth-child(1),
          .col:nth-child(2) {
            .dropdown {
              button {
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }

        .selected_file {
          display: flex;
          align-items: center;

          .selected_file_wrap {
            flex-direction: column;

            .file_upload_wrap {
              margin-bottom: 0;
              display: flex;

              img {
                width: 25px;
                height: 25px;
              }

              p {
                font-weight: 700;
                margin-bottom: 5px;
                color: white;
                word-break: break-word;

                &::before {
                  margin-right: 10px;
                  content: '·';
                  font-weight: 700;
                  color: white;
                }
              }
            }
          }
        }

        .check_box_wrap {
          font-weight: 700;
          color: white;
          font-size: 18px;

        }

        .dropdown {
          .dropdown-menu {
            width: 100%;
            max-height: 250px;
            overflow-y: auto;

            p {
              &:hover {
                cursor: pointer;
              }
            }
          }

          button {
            @include dropdown-btn;
            width: 100%;
            color: black;
            justify-content: space-between;
            align-items: center;
          }
        }

        .input-group {
          flex-wrap: nowrap;

          .file_upload_wrap {
            margin-bottom: 0;
            display: flex;

            img {
              width: 25px;
              height: 25px;
            }

            p {
              margin-bottom: 0;
              font-weight: 700;
              color: white;

              &::before {
                margin-right: 10px;
                content: '·';
                font-weight: 700;
                color: white;
              }
            }
          }

          .form-control {
            height: 35px;
            border-radius: 0;
          }

          .input-group-prepend {
            color: white;
            font-weight: 700;
            font-size: 20px;
            width: 120px;
            text-align: end;
            white-space: nowrap;
          }

          .file_wrap {
            display: flex;
            flex-direction: column;
          }

          .choose_btn {
            margin-bottom: 10px;
            @include choose_file_btn;

            &:hover {
              background: #3f608f;
            }
          }
        }
      }
    }
  }
}

@media only screen and (min-width: 1200px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 850px;

      .content {
        .input-group {
          justify-content: end;
          flex-wrap: nowrap;

          .input-number,
          .form-select {
            width: 75%;
          }

          .readonly_box {
            height: 37px;
          }

          .form-control {
            height: 37px;
            border-radius: 0;
          }

          .input-group-prepend {
            text-align: end;
            width: 138px;
          }
        }
      }

      .tab_section {
        .dropdown {
          width: 60%;
        }

        .tab-content {
          padding: 50px 30px;

          .storage_dropdown {

            .col:nth-child(1),
            .col:nth-child(2) {
              .dropdown {
                button {
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }

          .check_box_wrap {
            align-items: center;

            div:nth-child(2) {
              gap: 0 10px;
            }
          }

          .input-group {

            .input-number,
            .form-select {
              width: 60%;
            }

            .file_upload_wrap {
              margin-bottom: 0;
              display: flex;

              img {
                width: 25px;
                height: 25px;
              }

              p {
                margin-bottom: 0;
                font-weight: 700;
                color: white;

                &::before {
                  margin-right: 10px;
                  content: '·';
                  font-weight: 700;
                  color: white;
                }
              }
            }


            .input-group-prepend {
              width: 120px;
              text-align: end;
              white-space: nowrap;
            }

            .file_wrap {
              display: flex;
              flex-direction: column;
            }

          }
        }
      }
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1199px) {
  .main_section {
    .info_wrap {
      margin: 8px auto 5%;
      width: 800px;
      padding: 0 5%;

      .content {
        .input-group {
          justify-content: end;
          width: 100%;
          flex-wrap: nowrap;

          .input-number,
          .form-select {
            width: 100%;
          }

          .input-group-prepend {
            text-align: end;
            width: 150px;
          }
        }
      }

      .tab_section {
        .dropdown {
          width: 60%;
        }

        .tab-content {
          padding: 25px;

          .storage_dropdown {

            .col:nth-child(1),
            .col:nth-child(2) {
              .dropdown {
                button {
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }

          .check_box_wrap {
            align-items: center;

            div:nth-child(2) {
              gap: 0 10px;
            }
          }

          .input-group {

            .input-number,
            .form-select {
              width: 60%;
            }

            .file_upload_wrap {
              margin-bottom: 0;
              display: flex;

              img {
                width: 25px;
                height: 25px;
              }

              p {
                margin-bottom: 0;
                font-weight: 700;
                color: white;

                &::before {
                  margin-right: 10px;
                  content: '·';
                  font-weight: 700;
                  color: white;
                }
              }
            }


            .input-group-prepend {
              width: 119px;
              text-align: end;
              white-space: nowrap;
            }

            .file_wrap {
              display: flex;
              flex-direction: column;

            }
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .main_section {
    .readonly_box {
      margin-top: 5px;
    }

    .readonly_box,
    .input-number,
    .form-select,
    .form-control {
      margin-left: unset !important;
    }

    .info_wrap {
      padding: 0 5%;

      .fixed_info {
        height: unset;
        flex-direction: column;
        padding: 10px;
      }

      .content {
        .input-group {
          flex-direction: column;

          .input-group> :not(:first-child) {
            margin-left: unset;
            border-radius: 5px;
            margin-top: 5px;
            height: 35px;
          }

          .input-number,
          .form-control {
            margin-top: 5px;
          }

          .form-select {
            width: 100%;
          }

          .input-group-prepend {
            width: 100px;
            white-space: nowrap;
          }
        }
      }

      .tab_section {

        .input-group> :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
          margin-left: unset !important;
        }

        .tab-content {
          padding: 50px 30px;

          .storage_dropdown {
            display: flex;
            flex-direction: column;

            .apply_btn {
              margin-top: 10px;
            }
          }

          .selected_file {
            .input-group {
              flex-direction: column;
            }

          }

          .check_box_wrap {
            div:nth-child(2) {
              gap: 0 10px;
              display: flex;
            }
          }

          .input-group {
            flex-direction: column;

            .form-control {
              width: 100%;
              margin-left: unset !important;
            }

            .input-group-prepend {
              width: 100%;
              display: flex;
              justify-content: left
            }

            .file_wrap {
              display: flex;
              flex-direction: column;

            }
          }
        }
      }
    }
  }
}
</style>